<template>
  <div class="container">
    <router-link class="d-block mb-2" to="/admin/settings/html_pages"
      >← HTMLページ一覧に戻る</router-link
    >
    <h2 class="headline mb-3">HTMLページ基本設定</h2>
    <v-form ref="htmlPageForm" style="width: 100%">
      <v-row>
        <v-col>
          <v-text-field
            v-model="htmlPage.title"
            class="mb-3"
            label="ページ名"
            :rules="[presenceValidation]"
            required
          >
            <template v-slot:label>
              <InputLabel label-name="ページ名" :required="true" />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="12" class="pb-0">
          <InputLabel
            label-name="パーマリンク"
            class="text-caption"
            :required="true"
          />
        </v-col>
        <v-col lg="12" class="d-flex">
          <span class="pt-1 px-2"
            >{{ site.original_domain_with_protocol }}/lp/</span
          >
          <v-text-field
            v-model="htmlPage.slug"
            class="pt-0 ma-0"
            style="max-width: 150px"
            :rules="[presenceValidation]"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox v-model="htmlPage.isIndex" label="インデックスする" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn-toggle v-model="htmlPage.published" outlined mandatory>
            <v-btn :value="true"> 公開 </v-btn>
            <v-btn :value="false"> 非公開 </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox v-model="htmlPage.displayHeaderFooter" label="ヘッダーとフッターを表示する" />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    InputLabel
  },
  mixins: [formValidationUtils],
  props: {
    htmlPage: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    })
  }
}
</script>
